import { render, staticRenderFns } from "./oopsBanner2.vue?vue&type=template&id=744ae596&scoped=true"
import script from "./oopsBanner2.vue?vue&type=script&lang=js"
export * from "./oopsBanner2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ae596",
  null
  
)

export default component.exports